import React, { useState } from "react";
import {
  Dialog, DialogTitle, DialogContent, IconButton, Grid, Typography,
  Box, Button, TextField, Alert, Slide, Paper
} from "@mui/material";
import { Close as CloseIcon } from "@mui/icons-material";
import { putData } from "../../BaseUrl";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const ReadOnlyField = ({ label, value }) => (
  <TextField
    label={label}
    value={value || ""}
    size="small"
    fullWidth
    InputProps={{ readOnly: true }}
    sx={{ mb: 2 }}
  />
);

const WithdrawalDetailDialog = ({ open, onClose, record, onSuccess }) => {
  const [approveCredential, setApproveCredential] = useState("");
  const [rejectReason, setRejectReason] = useState("");
  const [loading, setLoading] = useState(false);

  if (!record) return null;

  const handleApprove = async () => {
    setLoading(true);
    try {
      await putData(`admin/payment/withdrawals/${record.id}`, {
        status: "approved"
      });
      onSuccess("Withdrawal approved successfully");
    } catch (err) {
      setLoading(false);
    }
  };

  const handleReject = async () => {
    setLoading(true);
    try {
      await putData(`admin/payment/withdrawals/${record.id}`, {
        status: "rejected"
      });
      onSuccess("Withdrawal rejected");
    } catch (err) {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="lg" fullWidth TransitionComponent={Transition}>
      <DialogTitle sx={{ p: 0 }}>
        {/* Gradient Header Banner */}
        <Box sx={{
          background: "linear-gradient(135deg, #244C77 0%, #4A7BA8 100%)",
          p: 3, position: "relative", color: "#fff"
        }}>
          <IconButton onClick={onClose} size="small"
            sx={{ position: "absolute", top: 12, right: 12, color: "#fff" }}>
            <CloseIcon />
          </IconButton>
          <Typography variant="h6" fontWeight="bold">
            {record.studentName || record.name || "Student"}
          </Typography>
          <Box sx={{
            display: "inline-block", mt: 1, px: 1.5, py: 0.5,
            backgroundColor: "rgba(255,255,255,0.2)", borderRadius: 1
          }}>
            <Typography variant="caption" sx={{ color: "#fff" }}>
              Student ID: {record.registrationNumber || record.regNo || record.studentId || "-"}
            </Typography>
          </Box>
        </Box>
      </DialogTitle>

      <DialogContent sx={{ p: 0 }}>
        <Grid container>
          {/* Left: Form Details */}
          <Grid item xs={12} md={7} sx={{ p: 3, borderRight: { md: "1px solid #e0e0e0" } }}>
            {/* Eligibility Alert */}
            <Alert severity="info" sx={{ mb: 3, backgroundColor: "#fff8e1", color: "#f57f17",
              "& .MuiAlert-icon": { color: "#f57f17" } }}>
              This Request is Eligible for Refund
            </Alert>

            <Typography variant="subtitle1" fontWeight="bold" color="#1a237e" mb={2}>
              Withdrawal Details
            </Typography>

            <ReadOnlyField label="Student ID"
              value={record.registrationNumber || record.regNo || record.studentId} />
            <ReadOnlyField label="Student Name" value={record.studentName || record.name} />

            <Grid container spacing={2}>
              <Grid item xs={6}>
                <TextField label="Grade" value={record.grade || ""} size="small" fullWidth
                  InputProps={{ readOnly: true }} sx={{ mb: 2 }} />
              </Grid>
              <Grid item xs={6}>
                <TextField label="Section" value={record.section || ""} size="small" fullWidth
                  InputProps={{ readOnly: true }} sx={{ mb: 2 }} />
              </Grid>
            </Grid>

            <TextField label="Parent Name" value={record.parentName || ""} size="small" fullWidth
              InputProps={{ readOnly: true }} sx={{ mb: 2 }} />
            <TextField label="Parent Phone No" value={record.parentPhone || ""} size="small" fullWidth
              InputProps={{ readOnly: true }} sx={{ mb: 2 }} />
            <TextField label="Parent Email ID" value={record.parentEmail || record.email || ""} size="small"
              fullWidth InputProps={{ readOnly: true }} sx={{ mb: 2 }} />
            <TextField label="Date" value={record.date || record.createdAt?.slice(0, 10) || ""} size="small"
              fullWidth InputProps={{ readOnly: true }} sx={{ mb: 2 }} />
            <TextField label="Reason For Withdrawal" value={record.reasonForWithdrawal || record.reason || ""}
              size="small" fullWidth multiline rows={3} InputProps={{ readOnly: true }} sx={{ mb: 2 }} />
          </Grid>

          {/* Right: Action Panels */}
          <Grid item xs={12} md={5} sx={{ p: 3, backgroundColor: "#fafafa" }}>
            {/* Approve Panel */}
            <Paper sx={{ p: 2, mb: 3, borderRadius: 2, border: "1px solid #e0e0e0" }}>
              <Typography variant="subtitle2" fontWeight="bold" color="#2e7d32" mb={2}>
                Approve Application
              </Typography>
              <TextField
                label="User Credential"
                placeholder="Enter your credential to approve"
                value={approveCredential}
                onChange={(e) => setApproveCredential(e.target.value)}
                multiline rows={3} size="small" fullWidth sx={{ mb: 2 }}
              />
              <Button
                variant="contained"
                fullWidth
                disabled={loading || !approveCredential}
                onClick={handleApprove}
                sx={{
                  backgroundColor: "#4caf50",
                  "&:hover": { backgroundColor: "#388e3c" },
                  textTransform: "none", fontWeight: 600
                }}
              >
                Approve & Assign
              </Button>
            </Paper>

            {/* Reject Panel */}
            <Paper sx={{ p: 2, borderRadius: 2, border: "1px solid #e0e0e0" }}>
              <Typography variant="subtitle2" fontWeight="bold" color="#c62828" mb={2}>
                Reject Application
              </Typography>
              <TextField
                label="Reason for Rejection"
                placeholder="Enter reason for rejection"
                value={rejectReason}
                onChange={(e) => setRejectReason(e.target.value)}
                multiline rows={3} size="small" fullWidth sx={{ mb: 2 }}
              />
              <Button
                variant="contained"
                fullWidth
                disabled={loading || !rejectReason}
                onClick={handleReject}
                sx={{
                  backgroundColor: "#f44336",
                  "&:hover": { backgroundColor: "#c62828" },
                  textTransform: "none", fontWeight: 600
                }}
              >
                Reject
              </Button>
            </Paper>
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
};

export default WithdrawalDetailDialog;
